import { createSlice } from '@reduxjs/toolkit';

import { updateSearchParams } from '../common/reducers/updateSearchParams.reducers';

import { INITIAL_ERRORED_DOCUMENTS_STATE } from './errored.state';

const slice = createSlice({
  name: 'erroredDocuments',
  initialState: INITIAL_ERRORED_DOCUMENTS_STATE,
  reducers: {
    updateSearchParams,

    toggleShowRead: (state) => {
      state.dashboardView.searchParams.showRead = !state.dashboardView.searchParams.showRead;
    },
  },
});

export const documentErroredReducer = slice.reducer;

export const ErroredDocumentsActions = slice.actions;
